import { AddCircleIcon } from "./product/AddCircleIcon";
import {
  AnthropicIcon,
  DeepseekIcon,
  GeminiIcon,
  MistralIcon,
  OpenAiIcon,
} from "./product/AiProviderIcons";
import { AddIcon } from "./product/AddIcon";
import { AlarmClockIcon } from "./product/AlarmClockIcon";
import { AlertOctagonIcon } from "./product/AlertOctagonIcon";
import { ArchiveIcon } from "./product/ArchiveIcon";
import { ArrowDownIcon } from "./product/ArrowDownIcon";
import { ArrowExternalIcon } from "./product/ArrowExternalIcon";
import { ArrowLeftIcon } from "./product/ArrowLeftIcon";
import { ArrowLeftToLineIcon } from "./product/ArrowLeftToLineIcon";
import { ArrowRightIcon } from "./product/ArrowRightIcon";
import { ArrowRightToLineIcon } from "./product/ArrowRightToLineIcon";
import { ArrowUp10Icon } from "./product/ArrowUp10Icon";
import { ArrowUpIcon } from "./product/ArrowUpIcon";
import { AsteriskIcon } from "./product/AsteriskIcon";
import { AudioLinesIcon } from "./product/AudioLinesIcon";
import { AzureIcon } from "./product/AzureIcon";
import { BarChartIcon } from "./product/BarChartIcon";
import { BadgeQuestionMarkIcon } from "./product/BadgeQuestionMarkIcon";
import { BinocularsIcon } from "./product/BinocularsIcon";
import { BlendIcon } from "./product/BlendIcon";
import { BoldCrossIcon } from "./marketing/BoldCrossIcon";
import { BoxIcon } from "./product/BoxIcon";
import { BookKeyIcon } from "./product/BookKeyIcon";
import { BoxesIcon } from "./product/BoxesIcon";
import { BlocksIcon } from "./product/BlocksIcon";
import { BrainIcon } from "./product/BrainIcon";
import { BracketsIcon } from "./product/BracketsIcon";
import { BugIcon } from "./product/BugIcon";
import { BuildingIcon } from "./product/BuildingIcon";
import { CableIcon } from "./product/CableIcon";
import { CalendarCogIcon } from "./product/CalendarCogIcon";
import { BullseyeIcon } from "./product/BullseyeIcon";
import { CameraIcon } from "./product/CameraIcon";
import { ChalkLogoIcon } from "./marketing/ChalkLogoIcon";
import { ChalkSqlIcon } from "./product/ChalkSqlIcon";
import { ChartNoAxesGanttIcon } from "./product/ChartNoAxesGanttIcon";
import { ChartColumnBigIcon } from "./product/ChartColumnBigIcon";
import { ChartIcon } from "./product/ChartIcon";
import { ChartLineIcon } from "./product/ChartLineIcon";
import { CheckMarkIcon } from "./product/CheckMarkIcon";
import { CheckSquareIcon } from "./product/CheckSquareIcon";
import { ChevronDownIcon } from "./product/ChevronDownIcon";
import { ChevronLeftIcon } from "./product/ChevronLeftIcon";
import { ChevronRightIcon } from "./product/ChevronRightIcon";
import { ChevronUpIcon } from "./product/ChevronUpIcon";
import { ChevronsLeftIcon } from "./product/ChevronsLeftIcon";
import { ChevronsUpDownIcon } from "./product/ChevronsUpDownIcon";
import { CircleIcon } from "./product/CircleIcon";
import { CirclePileIcon } from "./product/CirclePileIcon";
import { ClockIcon } from "./product/ClockIcon";
import { CloseIcon } from "./product/CloseIcon";
import { CloudDownloadIcon } from "./product/CloudDownloadIcon";
import { CloudServerIcon } from "./product/CloudServerIcon";
import { CloudUploadIcon } from "./product/CloudUploadIcon";
import { CloudsIcon } from "./product/CloudsIcon";
import { CmdIcon } from "./product/CmdIcon";
import { CodeIcon } from "./product/CodeIcon";
import { CogIcon } from "./product/CogIcon";
import { ColumnIcon } from "./product/ColumnIcon";
import { Columns2Icon } from "./product/Columns2Icon";
import { CompassIcon } from "./product/CompassIcon";
import { ComputerIcon } from "./product/ComputerIcon";
import { ContainerIcon } from "./product/ContainerIcon";
import { ContentChartIcon } from "./marketing/ContentChartIcon";
import { CopyIcon } from "./product/CopyIcon";
import { CornerDownLeftIcon } from "./product/CornerDownLeftIcon";
import { CpuIcon } from "./product/CpuIcon";
import { CriticalIcon } from "./product/CriticalIcon";
import { CubeNetworkIcon } from "./marketing/CubeNetworkIcon";
import { CylinderIcon } from "./product/CylinderIcon";
import { DatabaseIcon } from "./product/DatabaseIcon";
import { DatabaseZapIcon } from "./product/DatabaseZapIcon";
import { DataEngineeringIcon } from "./product/DataEngineeringIcon";
import { DataScienceIcon } from "./product/DataScienceIcon";
import { DeleteIcon } from "./product/DeleteIcon";
import { DependabotIcon } from "./product/DependabotIcon";
import { DocsIcon } from "./product/DocsIcon";
import { DownloadIcon } from "./product/DownloadIcon";
import { EditIcon } from "./product/EditIcon";
import { EngineeringIcon } from "./product/EngineeringIcon";
import { EnvironmentIcon } from "./product/EnvironmentIcon";
import { ErrorIcon } from "./product/ErrorIcon";
import { ExpandIcon } from "./product/ExpandIcon";
import { FeatureIcon } from "./product/FeatureIcon";
import { FileCodeIcon } from "./product/FileCodeIcon";
import { FileIcon } from "./product/FileIcon";
import { FlagIcon } from "./product/FlagIcon";
import { FingerprintIcon } from "./product/FingerprintIcon";
import { FilterIcon } from "./product/FilterIcon";
import { FileUpIcon } from "./product/FileUpIcon";
import { FolderIcon } from "./product/FolderIcon";
import { FoldersIcon } from "./product/FoldersIcon";
import { FoodForkSpoonIcon } from "./marketing/FoodForkSpoonIcon";
import { ForkIcon } from "./product/ForkIcon";
import { ForwardIcon } from "./product/ForwardIcon";
import { GitBranchIcon } from "./product/GitBranchIcon";
import { GitHubIcon } from "./product/GitHubIcon";
import { GridIcon } from "./product/GridIcon";
import { GripVerticalIcon } from "./product/GripVerticalIcon";
import { GroupIcon } from "./marketing/GroupIcon";
import { HandshakeIcon } from "./product/HandshakeIcon";
import { HardDriveIcon } from "./product/HardDriveIcon";
import { HardDriveOffIcon } from "./product/HardDriveOffIcon";
import { HeartIcon } from "./product/HeartIcon";
import { HeartPulseIcon } from "./product/HeartPulseIcon";
import { HexagonIcon } from "./product/HexagonIcon";
import { HomeIcon } from "./product/HomeIcon";
import { HorizontalListQueryIcon } from "./product/HorizontalListQueryIcon";
import { HorizontalServerIcon } from "./product/HorizontalServerIcon";
import { InfinityIcon } from "./product/InfinityIcon";
import { InfoIcon } from "./product/InfoIcon";
import { InspectionPanelIcon } from "./product/InspectionPanelIcon";
import { InterfaceFileIcon } from "./product/InterfaceFileIcon";
import { KeyIcon } from "./product/KeyIcon";
import { KeyRoundIcon } from "./product/KeyRoundIcon";
import { KeySquareIcon } from "./product/KeySquareIcon";
import { LayersIcon } from "./product/LayersIcon";
import { LifeBuoyIcon } from "./product/LifeBuoyIcon";
import { LibraryBigIcon } from "./product/LibraryBigIcon";
import { LibraryIcon } from "./product/LibraryIcon";
import { LinkedInIcon } from "./product/LinkedInIcon";
import { LinkIcon } from "./product/LinkIcon";
import { ListIcon } from "./product/ListIcon";
import { ListTreeIcon } from "./product/ListTreeIcon";
import { LocationPinIcon } from "./marketing/LocationPinIcon";
import { LockKeyholeOpenIcon } from "./product/LockKeyholeOpenIcon";
import { LockIcon } from "./product/LockIcon";
import { LockOpenIcon } from "./product/LockOpenIcon";
import { LogOutIcon } from "./product/LogOutIcon";
import { MessageCircleIcon } from "./product/MessageCircleIcon";
import { MessageSquareMoreIcon } from "./product/MessageSquareMoreIcon";
import { MessageSquareIcon } from "./product/MessageSquareIcon";
import { MicrochipIcon } from "./product/MicrochipIcon";
import { MoneyBankIcon } from "./marketing/MoneyBankIcon";
import { MinimizeIcon } from "./product/MinimizeIcon";
import { MoonIcon } from "./product/MoonIcon";
import { MoreIcon } from "./product/MoreIcon";
import { MoveUpIcon } from "./product/MoveUpIcon";
import { NetworkIcon } from "./product/NetworkIcon";
import { NotebookIcon } from "./product/NotebookIcon";
import { NotificationsIcon, NotificationsOffIcon } from "./product/NotificationsIcon";
import { OfflineIcon } from "./product/OfflineIcon";
import { OnlineIcon } from "./product/OnlineIcon";
import { OctagonPauseIcon } from "./product/OctagonPauseIcon";
import { PackageIcon } from "./product/PackageIcon";
import { PaintBucketIcon } from "./product/PaintBucketIcon";
import { PanelLeftDashedIcon } from "./product/PanelLeftDashedIcon";
import { ParenthesesIcon } from "./product/ParenthesesIcon";
import { PawPrintIcon } from "./product/PawPrintIcon";
import { PhoneArrowUpRightIcon } from "./product/PhoneArrowUpRightIcon";
import { PersonalizationIcon } from "./product/PersonalizationIcon";
import { PhoneListIcon } from "./marketing/PhoneListIcon";
import { PhoneLoadingIcon } from "./marketing/PhoneLoadingIcon";
import { PlugIcon } from "./product/PlugIcon";
import { ProgrammingBrowserCodeIcon } from "./product/ProgrammingBrowserCodeIcon";
import { ProgrammingBrowserSearchIcon } from "./product/ProgrammingBrowserSearchIcon";
import { QuestionIcon } from "./product/QuestionIcon";
import { RadarIcon } from "./product/RadarIcon";
import { RemoveCircleIcon } from "./product/RemoveCircleIcon";
import { RemoveIcon } from "./product/RemoveIcon";
import { ResolverIcon } from "./product/ResolverIcon";
import { RetryIcon } from "./product/RetryIcon";
import { RedStatusDotIcon } from "./product/RedStatusDotIcon";
import { RouteIcon } from "./product/RouteIcon";
import { RunIcon } from "./product/RunIcon";
import { SailboatIcon } from "./product/SailboatIcon";
import { RectangleCircleIcon } from "./product/RectangleCircleIcon";
import { SaveIcon } from "./product/SaveIcon";
import { SaveMultipleIcon } from "./product/SaveMultipleIcon";
import { ScaleIcon } from "./product/ScaleIcon";
import { ScanFaceIcon } from "./product/ScanFaceIcon";
import { SchemaIcon } from "./product/SchemaIcon";
import { SearchIcon } from "./product/SearchIcon";
import { SelectIcon } from "./product/SelectIcon";
import { ServerIcon } from "./product/ServerIcon";
import { ServersIcon } from "./product/ServersIcon";
import { SettingsIcon } from "./product/SettingsIcon";
import { Share2Icon } from "./product/Share2Icon";
import { ShareIcon } from "./product/ShareIcon";
import { ShieldIcon } from "./product/ShieldIcon";
import { ShipWheelIcon } from "./product/ShipWheelIcon";
import { ShovelIcon } from "./product/ShovelIcon";
import { SidebarIcon } from "./product/SidebarIcon";
import { SliceIcon } from "./product/SliceIcon";
import { SlackIcon } from "./product/SlackIcon";
import { SlidersIcon } from "./product/SlidersIcon";
import { SmileyIcon } from "./product/SmileyIcon";
import { SnowflakeIcon } from "./product/SnowflakeIcon";
import { SparkleIcon } from "./product/SparkleIcon";
import { SparklesIcon } from "./product/SparklesIcon";
import { TelescopeIcon } from "./product/TelescopeIcon";
import { MousePointer2Icon } from "./product/MousePointer2Icon";
import { SplitIcon } from "./product/SplitIcon";
import { SportShoeIcon } from "./product/SportShoeIcon";
import { SqlFileIcon } from "./product/SqlFileIcon";
import { StackIcon } from "./product/StackIcon";
import { SquareAsteriskIcon } from "./product/SquareAsteriskIcon";
import { SquareFunctionIcon } from "./product/SquareFunctionIcon";
import { StarIcon } from "./product/StarIcon";
import { StoreIcon } from "./product/StoreIcon";
import { StoneIcon } from "./product/StoneIcon";
import { StreamIcon } from "./product/StreamIcon";
import { SquareTerminalIcon } from "./product/SquareTerminalIcon";
import { SunIcon } from "./product/SunIcon";
import { TableIcon } from "./product/TableIcon";
import { TagIcon } from "./product/TagIcon";
import { TerminalIcon } from "./product/TerminalIcon";
import { TextAlignJustifyIcon } from "./product/TextAlignJustifyIcon";
import { TextInitialIcon } from "./product/TextInitialIcon";
import { TextSearchIcon } from "./product/TextSearchIcon";
import { TicketIcon } from "./product/TicketIcon";
import { TrafficConeIcon } from "./product/TrafficConeIcon";
import { TravelAirportIcon } from "./marketing/TravelAirportIcon";
import { TravelBeachIcon } from "./marketing/TravelBeachIcon";
import { TravelBusIcon } from "./marketing/TravelBusIcon";
import { TravelCarIcon } from "./marketing/TravelCarIcon";
import { UIIcon } from "./product/UIIcon";
import { UnplugIcon } from "./product/UnplugIcon";
import { UploadIcon } from "./product/UploadIcon";
import { UserIcon } from "./product/UserIcon";
import { UserRoundIcon } from "./product/UserRoundIcon";
import { VectorSquareIcon } from "./product/VectorSquareIcon";
import { VersionIcon } from "./product/VersionIcon";
import { VideoIcon } from "./product/VideoIcon";
import { WarningIcon } from "./product/WarningIcon";
import { WavesLadderIcon } from "./product/WavesLadderIcon";
import { WaypointsIcon } from "./product/WaypointsIcon";
import { WebhookIcon } from "./product/WebhookIcon";
import { WhatnotLogoIcon } from "./product/WhatnotLogoIcon";
import { WorkflowIcon } from "./product/WorkflowIcon";
import { WrenchIcon } from "./product/WrenchIcon";
import { ZapIcon } from "./product/ZapIcon";
import { CalendarIcon } from "./product/CalendarIcon";
import { MapPinIcon } from "./product/MapPinIcon";
import {
  ALargeSmall,
  ArrowDownAZ,
  ArrowLeftRight,
  ArrowUpDown,
  AtSign,
  CalendarArrowDown,
  CaseSensitive,
  ChevronsLeftRight,
  ChevronsLeftRightEllipsis,
  ChartPie,
  CircleOff,
  Crosshair,
  DecimalsArrowRight,
  Eye,
  EllipsisVertical,
  EyeOff,
  FileBraces,
  FileDiff,
  FileCog,
  FileJson,
  FileTerminal,
  FileText,
  Gauge,
  History,
  Keyboard,
  LayoutDashboard,
  ListVideo,
  Maximize2,
  Pin,
  PinOff,
  Plus,
  RefreshCw,
  ToggleRight,
  Type,
  Repeat,
  RotateCcw,
  Rocket,
  Cuboid,
  ExternalLink,
  FunctionSquare,
  GlobeLock,
  Images,
  ListOrdered,
  PackageOpen,
  Paperclip,
  Percent,
  Rows4,
  ScanEye,
  ShieldAlert,
  Square,
  TableProperties,
  ThumbsDown,
  ThumbsUp,
  Undo,
  Undo2,
  Users,
  ZoomIn,
  ZoomOut,
} from "lucide-react";
import { createLucideIcon, isLucideIcon } from "./product/createLucideIcon";
import { ExpandSquareIcon } from "@/components/icons/marketing/ExpandSquareIcon";
import { NetworkZIcon } from "@/components/icons/marketing/NetworkZIcon";
import { NetworkSquareIcon } from "@/components/icons/marketing/NetworkSquareIcon";

const ChartPieIcon = createLucideIcon(ChartPie);
const Maximize2Icon = createLucideIcon(Maximize2);
const CircleOffIcon = createLucideIcon(CircleOff);
const CrosshairIcon = createLucideIcon(Crosshair);
const DecimalsArrowRightIcon = createLucideIcon(DecimalsArrowRight);
const FileBracesIcon = createLucideIcon(FileBraces);
const FileDiffIcon = createLucideIcon(FileDiff);
const FileCogIcon = createLucideIcon(FileCog);
const FileJsonIcon = createLucideIcon(FileJson);
const FileTerminalIcon = createLucideIcon(FileTerminal);
const FileTextIcon = createLucideIcon(FileText);
const BoxLongIcon = createLucideIcon(Cuboid);
const ArrowDownAZIcon = createLucideIcon(ArrowDownAZ);
const ArrowsLeftRightIcon = createLucideIcon(ArrowLeftRight);
const ArrowsUpDownIcon = createLucideIcon(ArrowUpDown);
const ArrowUpDownIcon = createLucideIcon(ArrowUpDown);
const AtSignIcon = createLucideIcon(AtSign);
const CalendarArrowDownIcon = createLucideIcon(CalendarArrowDown);
const ChevronsEllipsisIcon = createLucideIcon(ChevronsLeftRightEllipsis);
const MoreVerticalIcon = createLucideIcon(EllipsisVertical);
const ChevronsLeftRightIcon = createLucideIcon(ChevronsLeftRight);
const PinIcon = createLucideIcon(Pin);
const PinOffIcon = createLucideIcon(PinOff);
const PlusIcon = createLucideIcon(Plus);
const RepeatIcon = createLucideIcon(Repeat);
const EyeIcon = createLucideIcon(Eye);
const EyeOffIcon = createLucideIcon(EyeOff);
const EyeSquareIcon = createLucideIcon(ScanEye);
const StopIcon = createLucideIcon(Square);
const ExternalLinkIcon = createLucideIcon(ExternalLink);
const FunctionSquareIcon = createLucideIcon(FunctionSquare);
const GaugeIcon = createLucideIcon(Gauge);
const HistoryIcon = createLucideIcon(History);
const ListVideoIcon = createLucideIcon(ListVideo);
const GlobeLockIcon = createLucideIcon(GlobeLock);
const ImagesIcon = createLucideIcon(Images);
const ListNumberedIcon = createLucideIcon(ListOrdered);
// One large panel beside smaller ones: the shape of a tree map, which lucide has no icon for.
const TreeMapIcon = createLucideIcon(LayoutDashboard);
const KeyboardIcon = createLucideIcon(Keyboard);
const PackageOpenIcon = createLucideIcon(PackageOpen);
const PaperclipIcon = createLucideIcon(Paperclip);
const PercentIcon = createLucideIcon(Percent);
const Rows4Icon = createLucideIcon(Rows4);
const TablePropertiesIcon = createLucideIcon(TableProperties);
const RefreshCwIcon = createLucideIcon(RefreshCw);
const ToggleRightIcon = createLucideIcon(ToggleRight);
const ALargeSmallIcon = createLucideIcon(ALargeSmall);
const TypeIcon = createLucideIcon(Type);
const RotateCcwIcon = createLucideIcon(RotateCcw);
const RocketIcon = createLucideIcon(Rocket);
const ShieldAlertIcon = createLucideIcon(ShieldAlert);
const CaseSensitiveIcon = createLucideIcon(CaseSensitive);
const UndoIcon = createLucideIcon(Undo);
const Undo2Icon = createLucideIcon(Undo2);
const UsersIcon = createLucideIcon(Users);
const ZoomInIcon = createLucideIcon(ZoomIn);
const ZoomOutIcon = createLucideIcon(ZoomOut);
const ThumbsDownIcon = createLucideIcon(ThumbsDown);
const ThumbsUpIcon = createLucideIcon(ThumbsUp);

export const iconMap = {
  aLargeSmall: ALargeSmallIcon,
  addCircle: AddCircleIcon,
  add: AddIcon,
  alarmClock: AlarmClockIcon,
  alertOctagon: AlertOctagonIcon,
  archive: ArchiveIcon,
  arrowDown: ArrowDownIcon,
  arrowDownAZ: ArrowDownAZIcon,
  arrowExternal: ArrowExternalIcon,
  arrowLeft: ArrowLeftIcon,
  arrowLeftToLine: ArrowLeftToLineIcon,
  arrowRight: ArrowRightIcon,
  arrowsLeftRight: ArrowsLeftRightIcon,
  arrowsUpDown: ArrowsUpDownIcon,
  arrowRightToLine: ArrowRightToLineIcon,
  arrowUpRight: ArrowExternalIcon,
  arrowUpDown: ArrowUpDownIcon,
  arrowUp10: ArrowUp10Icon,
  arrowUp: ArrowUpIcon,
  asterisk: AsteriskIcon,
  atSign: AtSignIcon,
  audioLines: AudioLinesIcon,
  azure: AzureIcon,
  barChart: BarChartIcon,
  badgeQuestionMark: BadgeQuestionMarkIcon,
  binoculars: BinocularsIcon,
  blend: BlendIcon,
  boldCross: BoldCrossIcon,
  bookKey: BookKeyIcon,
  box: BoxIcon,
  boxes: BoxesIcon,
  blocks: BlocksIcon,
  boxLong: BoxLongIcon,
  brain: BrainIcon,
  braces: BracketsIcon,
  brackets: BracketsIcon,
  bug: BugIcon,
  building: BuildingIcon,
  cable: CableIcon,
  bullseye: BullseyeIcon,
  calendar: CalendarIcon,
  calendarArrowDown: CalendarArrowDownIcon,
  calendarCog: CalendarCogIcon,
  camera: CameraIcon,
  caseSensitive: CaseSensitiveIcon,
  chalkLogo: ChalkLogoIcon,
  chalkSql: ChalkSqlIcon,
  anthropicLogo: AnthropicIcon,
  deepseekLogo: DeepseekIcon,
  geminiLogo: GeminiIcon,
  mistralLogo: MistralIcon,
  openaiLogo: OpenAiIcon,
  chartNoAxesGantt: ChartNoAxesGanttIcon,
  chartColumnBig: ChartColumnBigIcon,
  chart: ChartIcon,
  chartLine: ChartLineIcon,
  chartPie: ChartPieIcon,
  check: CheckMarkIcon,
  checkMark: CheckMarkIcon,
  checkSquare: CheckSquareIcon,
  chevronDown: ChevronDownIcon,
  chevronLeft: ChevronLeftIcon,
  chevronsEllipsis: ChevronsEllipsisIcon,
  chevronRight: ChevronRightIcon,
  chevronUp: ChevronUpIcon,
  chevronsLeft: ChevronsLeftIcon,
  chevronsLeftRight: ChevronsLeftRightIcon,
  chevronsUpDown: ChevronsUpDownIcon,
  circle: CircleIcon,
  circleOff: CircleOffIcon,
  circlePile: CirclePileIcon,
  clock: ClockIcon,
  close: CloseIcon,
  cloudDownload: CloudDownloadIcon,
  cloudServer: CloudServerIcon,
  cloudUpload: CloudUploadIcon,
  clouds: CloudsIcon,
  cmd: CmdIcon,
  code: CodeIcon,
  cog: CogIcon,
  column: ColumnIcon,
  columns2: Columns2Icon,
  compass: CompassIcon,
  computer: ComputerIcon,
  container: ContainerIcon,
  contentChart: ContentChartIcon,
  copy: CopyIcon,
  cornerDownLeft: CornerDownLeftIcon,
  crosshair: CrosshairIcon,
  cpu: CpuIcon,
  critical: CriticalIcon,
  cubeNetwork: CubeNetworkIcon,
  cylinder: CylinderIcon,
  database: DatabaseIcon,
  decimalsArrowRight: DecimalsArrowRightIcon,
  databaseZap: DatabaseZapIcon,
  dataEngineering: DataEngineeringIcon,
  dataScience: DataScienceIcon,
  delete: DeleteIcon,
  dependabot: DependabotIcon,
  docs: DocsIcon,
  download: DownloadIcon,
  edit: EditIcon,
  engineering: EngineeringIcon,
  environment: EnvironmentIcon,
  error: ErrorIcon,
  expand: ExpandIcon,
  expandSquare: ExpandSquareIcon,
  externalLink: ExternalLinkIcon,
  eye: EyeIcon,
  eyeOff: EyeOffIcon,
  eyeSquare: EyeSquareIcon,
  feature: FeatureIcon,
  fileBraces: FileBracesIcon,
  fileCode: FileCodeIcon,
  fileDiff: FileDiffIcon,
  file: FileIcon,
  fileCog: FileCogIcon,
  fileJson: FileJsonIcon,
  fileTerminal: FileTerminalIcon,
  fileText: FileTextIcon,
  fileUp: FileUpIcon,
  flag: FlagIcon,
  fingerprint: FingerprintIcon,
  filter: FilterIcon,
  folder: FolderIcon,
  folders: FoldersIcon,
  functionSquare: FunctionSquareIcon,
  foodForkSpoon: FoodForkSpoonIcon,
  fork: ForkIcon,
  forward: ForwardIcon,
  gauge: GaugeIcon,
  gitBranch: GitBranchIcon,
  gitHub: GitHubIcon,
  globeLock: GlobeLockIcon,
  grid: GridIcon,
  gripVertical: GripVerticalIcon,
  group: GroupIcon,
  handshake: HandshakeIcon,
  hardDrive: HardDriveIcon,
  hardDriveOff: HardDriveOffIcon,
  heart: HeartIcon,
  heartPulse: HeartPulseIcon,
  hexagon: HexagonIcon,
  history: HistoryIcon,
  home: HomeIcon,
  horizontalListQuery: HorizontalListQueryIcon,
  horizontalServer: HorizontalServerIcon,
  images: ImagesIcon,
  infinity: InfinityIcon,
  info: InfoIcon,
  inspectionPanel: InspectionPanelIcon,
  interfaceFile: InterfaceFileIcon,
  key: KeyIcon,
  keyboard: KeyboardIcon,
  keyRound: KeyRoundIcon,
  keySquare: KeySquareIcon,
  layers: LayersIcon,
  lifeBuoy: LifeBuoyIcon,
  libraryBig: LibraryBigIcon,
  library: LibraryIcon,
  linkedIn: LinkedInIcon,
  link: LinkIcon,
  list: ListIcon,
  listNumbered: ListNumberedIcon,
  listTree: ListTreeIcon,
  listVideo: ListVideoIcon,
  locationPin: LocationPinIcon,
  lock: LockIcon,
  lockKeyholeOpen: LockKeyholeOpenIcon,
  lockOpen: LockOpenIcon,
  logOut: LogOutIcon,
  mapPin: MapPinIcon,
  maximize2: Maximize2Icon,
  messageCircle: MessageCircleIcon,
  messageSquareMore: MessageSquareMoreIcon,
  messageSquare: MessageSquareIcon,
  microchip: MicrochipIcon,
  moneyBank: MoneyBankIcon,
  minimize: MinimizeIcon,
  moon: MoonIcon,
  more: MoreIcon,
  moreVertical: MoreVerticalIcon,
  mousePointer2: MousePointer2Icon,
  moveUp: MoveUpIcon,
  minus: RemoveIcon,
  network: NetworkIcon,
  networkSquare: NetworkSquareIcon,
  networkZ: NetworkZIcon,
  notebook: NotebookIcon,
  notifications: NotificationsIcon,
  notificationsOff: NotificationsOffIcon,
  offline: OfflineIcon,
  online: OnlineIcon,
  octagonPause: OctagonPauseIcon,
  package: PackageIcon,
  packageOpen: PackageOpenIcon,
  paperclip: PaperclipIcon,
  paintBucket: PaintBucketIcon,
  panelLeft: SidebarIcon,
  panelLeftDashed: PanelLeftDashedIcon,
  parentheses: ParenthesesIcon,
  pawPrint: PawPrintIcon,
  phoneArrowUpRight: PhoneArrowUpRightIcon,
  personalization: PersonalizationIcon,
  percent: PercentIcon,
  phoneList: PhoneListIcon,
  phoneLoading: PhoneLoadingIcon,
  pin: PinIcon,
  pinOff: PinOffIcon,
  plus: PlusIcon,
  plug: PlugIcon,
  pool: WavesLadderIcon,
  programmingBrowserCode: ProgrammingBrowserCodeIcon,
  programmingBrowserSearch: ProgrammingBrowserSearchIcon,
  question: QuestionIcon,
  radar: RadarIcon,
  rectangleCircle: RectangleCircleIcon,
  redStatusDot: RedStatusDotIcon,
  removeCircle: RemoveCircleIcon,
  remove: RemoveIcon,
  repeat: RepeatIcon,
  resolver: ResolverIcon,
  retry: RetryIcon,
  route: RouteIcon,
  rows4: Rows4Icon,
  rocket: RocketIcon,
  refreshCw: RefreshCwIcon,
  rotateCcw: RotateCcwIcon,
  run: RunIcon,
  sailboat: SailboatIcon,
  save: SaveIcon,
  saveMultiple: SaveMultipleIcon,
  scale: ScaleIcon,
  scanFace: ScanFaceIcon,
  schema: SchemaIcon,
  search: SearchIcon,
  select: SelectIcon,
  server: ServerIcon,
  servers: ServersIcon,
  settings: SettingsIcon,
  share2: Share2Icon,
  share: ShareIcon,
  shield: ShieldIcon,
  shieldAlert: ShieldAlertIcon,
  shipWheel: ShipWheelIcon,
  shovel: ShovelIcon,
  sidebar: SidebarIcon,
  slice: SliceIcon,
  slack: SlackIcon,
  sliders: SlidersIcon,
  smiley: SmileyIcon,
  snowflake: SnowflakeIcon,
  sparkle: SparkleIcon,
  sparkles: SparklesIcon,
  split: SplitIcon,
  sportShoe: SportShoeIcon,
  sqlFile: SqlFileIcon,
  stack: StackIcon,
  squareAsterisk: SquareAsteriskIcon,
  squareFunction: SquareFunctionIcon,
  star: StarIcon,
  stop: StopIcon,
  store: StoreIcon,
  stone: StoneIcon,
  stream: StreamIcon,
  squareTerminal: SquareTerminalIcon,
  sun: SunIcon,
  table: TableIcon,
  tableProperties: TablePropertiesIcon,
  tag: TagIcon,
  telescope: TelescopeIcon,
  terminal: TerminalIcon,
  textAlignJustify: TextAlignJustifyIcon,
  textInitial: TextInitialIcon,
  textSearch: TextSearchIcon,
  thumbsDown: ThumbsDownIcon,
  thumbsUp: ThumbsUpIcon,
  toggleRight: ToggleRightIcon,
  type: TypeIcon,
  ticket: TicketIcon,
  trafficCone: TrafficConeIcon,
  travelAirport: TravelAirportIcon,
  travelBeach: TravelBeachIcon,
  travelBus: TravelBusIcon,
  travelCar: TravelCarIcon,
  treeMap: TreeMapIcon,
  ui: UIIcon,
  undo: UndoIcon,
  undo2: Undo2Icon,
  unplug: UnplugIcon,
  upload: UploadIcon,
  user: UserIcon,
  userRound: UserRoundIcon,
  users: UsersIcon,
  variable: ResolverIcon,
  vectorSquare: VectorSquareIcon,
  version: VersionIcon,
  video: VideoIcon,
  warning: WarningIcon,
  wavesLadder: WavesLadderIcon,
  waypoints: WaypointsIcon,
  webhook: WebhookIcon,
  whatnotLogo: WhatnotLogoIcon,
  workflow: WorkflowIcon,
  wrench: WrenchIcon,
  x: CloseIcon,
  zap: ZapIcon,
  zoomIn: ZoomInIcon,
  zoomOut: ZoomOutIcon,
} as const;

export type IconName = keyof typeof iconMap;

export const isLucideIconName = (name: IconName): boolean => isLucideIcon(iconMap[name]);
